var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.partnerDetailsTabMetaData.componentName,_vm._b({ref:_vm.partnerDetailsTabMetaData.myRefName,tag:"component"},'component',_vm.partnerDetailsTabMetaData.props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }